import React from 'react'
import { Button, Card, Col, Flex, Rate, Row, Tag, Typography } from 'antd'
import { DollarOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { UnderlineDesign } from '../../UnderlineDesign'
import { QuoteCardData } from '../../../data'
import { useNavigate } from 'react-router-dom'

const { Title, Text } = Typography
const ProCards = () => {

    const navigate = useNavigate()

  return (
    <div className='mb-3'>
        <Row gutter={[24,24]}>
            <Col span={24}>
                <Flex vertical>
                    <Title level={3} className='gradient-text m-0 pt-3'>
                        List of Professionals
                    </Title>
                    <UnderlineDesign />
                </Flex>
            </Col>
            {
                QuoteCardData?.map((crdData,index)=>
                <Col lg={6} md={8} sm={24} xs={24} key={index}>
                    <Card
                        actions={[
                            <Flex justify='center'>
                                <Button className="btn fs-14 fw-400 p-2" onClick={()=> navigate('/quoteform')}>
                                    Get a Pro
                                </Button>
                            </Flex>
                        ]}
                        className='card-pro h-100'
                    >
                        <Flex vertical className='' gap={20}>
                            <Flex vertical align='center' gap={5}>
                                <Title level={4} className='m-0 text-center text-brand'
                                    style={{
                                        maxWidth: '100%',
                                      }}
                                      ellipsis={{
                                        rows: 1,
                                      }}
                                >
                                    {crdData?.title}
                                </Title>
                                <Title level={5} className='m-0 text-center'>{crdData?.subtitle}</Title>
                                <Rate value={4} style={{fontSize: 15}} />
                            </Flex>
                            <Flex vertical gap={2}>
                                <Text className='fs-14'><EnvironmentOutlined /> {crdData?.location} </Text>
                                <Text className='fs-14'><DollarOutlined /> {crdData?.amount} month</Text>
                                <Text className='fs-14'>{crdData?.exp} Year Experience</Text>
                                <Text className='fs-14'>{crdData?.email}</Text>
                            </Flex>
                            <Flex vertical gap={5}>
                                <Title level={5} className='m-0 text-center'>Skills:</Title>
                                <Flex wrap gap={5}>
                                    {
                                        crdData?.skills?.map((skill,i)=>
                                            <Tag key={i} className='text-brand border-brand'>
                                                {skill}
                                            </Tag>
                                        )
                                    }
                                </Flex>
                            </Flex>
                        </Flex>
                    </Card>
                </Col>
                )
            }
        </Row>
    </div>
  )
}

export {ProCards}